export const namingModes = [
    { Id: 0, Display: "CV Competence" },
    { Id: 1, Display: "Competence" },
    { Id: 2, Display: "Comment registered under person competence" }
];

export const inclusionModes = [
    { Id: 0, Display: "Most recent (only valid)" },
    { Id: 1, Display: "Most recent (including expired)" },
    { Id: 2, Display: "All" }
];


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencetypes/modes.ts